/**
 * Row reducer for the CPT table's editable (SEARCHABLE_CARD) description cell.
 * @module updateRowData/descriptionReducer
 */
import { CptCodeWithDetailsKeys } from "../../../../../../enums/tableColumnKeys";

/**
 * Handles a write-back from the SEARCHABLE_CARD-driven CPT description cell.
 *
 * The searchable-card cell emits its update as the full cell value
 * (`{ ...prevValue, value: newValue }`). We patch two slots on the row:
 *
 * - `Description.text` — keeps the human-readable description column in
 *   sync with the selection so downstream renderers see the new text.
 * - `CptCodesEditableDescription.value` — keeps the searchable card
 *   visually controlled (matching what `SearchableCardCell` reads as its
 *   `value` prop). Without this the dropdown trigger would not re-sync
 *   when the row is reverted via `revertTableToLastStateOnClose`.
 *
 * @param rowDataToUpdate - The current CPT-code row data.
 * @param updatedData - The new searchable-card cell payload (carries `value`).
 * @returns The row data with both `Description.text` and
 *   `CptCodesEditableDescription.value` patched.
 */
export const updateRowDataForCptCodesEditableDescription = (
  rowDataToUpdate: any,
  updatedData: any,
) => {
  return {
    ...rowDataToUpdate,
    [CptCodeWithDetailsKeys.Description]: {
      ...rowDataToUpdate[CptCodeWithDetailsKeys.Description],
      text: updatedData?.value ?? "",
    },
    [CptCodeWithDetailsKeys.CptCodesEditableDescription]: {
      ...rowDataToUpdate[CptCodeWithDetailsKeys.CptCodesEditableDescription],
      value: updatedData?.value ?? "",
    },
  };
};
